import type { AuthUser } from "./auth.server";

export type { AuthUser };

export function headerUser(user: AuthUser) {
  return {
    name: user.nombre,
    avatarUrl: user.avatarUrl,
    daysLeft: user.suscripcionActiva ? (user.diasRestantes ?? null) : null,
    hoursLeft: user.suscripcionActiva ? (user.horasRestantes ?? null) : null,
    minutesLeft: user.suscripcionActiva ? (user.minutosRestantes ?? null) : null,
    isAdmin: user.rol === "ADMIN",
  };
}

/** Texto de vigencia restante: días, horas (menos de un día) o minutos (menos de una hora). */
export function textoVigencia(dias: number, horas?: number | null, minutos?: number | null) {
  if (dias > 0) return `${dias} día${dias !== 1 ? "s" : ""} restantes`;
  if (dias < 0 || (horas != null && horas < 0)) return "Suscripción vencida";
  if (horas == null) return "Vence hoy";
  if (horas >= 1) return `${horas} hora${horas !== 1 ? "s" : ""} restantes`;
  if (minutos != null && minutos >= 1) return `${minutos} minuto${minutos !== 1 ? "s" : ""} restantes`;
  return "Menos de 1 minuto restante";
}
